/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef, useContext } from 'react';

import moment from 'moment';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import NoAvatar from '../../../../NoAvatar';
import DropdownOptions from '../../../../../../DropdownOptions';

import { UiContext } from '../../../../../../../context/UiContext';
import getResizedImageUrl from '../../../../../../../helpers/getResizedImageUrl';
import useOnClickOutside from '../../../../../../../hooks/useOnClickOutside';
import classes from './styles.module.scss';
import ChatService from '../../../../../../../services/ChatService';

export default function Contact({
  contact,
  activeContactId,
  setActiveContactId,
  refetchChatThreads,
}) {
  const [isContactMenuVisible, setIsContactMenuVisible] = useState(false);

  const { setIsFetching } = useContext(UiContext);

  const contactRef = useRef();

  useOnClickOutside(contactRef, () => setIsContactMenuVisible(false));

  const { t } = useTranslation();

  const showContactMenu = (event) => {
    event.preventDefault();
    setIsContactMenuVisible(true);
  };

  const pinContact = async () => {
    try {
      setIsFetching(true);
      await ChatService.pinContact({
        jobApplicationId: contact.jobApplication.id,
      });
      await refetchChatThreads();
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
    }
  };

  const unpinContact = async () => {
    try {
      setIsFetching(true);
      await ChatService.unpinContact({
        jobApplicationId: contact.jobApplication.id,
      });
      await refetchChatThreads();
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
    }
  };

  const createdAt = moment(contact.lastMessage?.createdAt);

  const isToday = createdAt.isSame(new Date(), 'day');
  const isYesterday = createdAt.isSame(moment().subtract(1, 'day'), 'day');

  let dateToDisplay = createdAt.format('Do MMM');
  console.log('Date to display: ', dateToDisplay);
  console.log('Last message: ', contact.lastMessage);
  if (isToday) {
    dateToDisplay = createdAt.format('hh:mm A');
  } else if (isYesterday) {
    dateToDisplay = 'Yesterday';
  }

  return (
    <li
      ref={contactRef}
      onContextMenu={showContactMenu}
      className={classNames(classes.Contact, {
        [classes.active]: activeContactId === contact.jobApplication.id,
      })}
      onClick={() => setActiveContactId(contact.jobApplication.id)}
    >
      {isContactMenuVisible && (
        <DropdownOptions
          left={206}
          top={84}
          options={[
            `${
              contact.isPinned
                ? t(
                    'dashboardComponents.Chat.LeftPanel.Contacts.ContactsList.Contact.unpin'
                  )
                : t(
                    'dashboardComponents.Chat.LeftPanel.Contacts.ContactsList.Contact.pin'
                  )
            }`,
            t(
              'dashboardComponents.Chat.LeftPanel.Contacts.ContactsList.Contact.mark'
            ),
          ]}
          width={154}
          changeOption={(option) => {
            if (
              option ===
              t(
                'dashboardComponents.Chat.LeftPanel.Contacts.ContactsList.Contact.pin'
              )
            ) {
              pinContact();
            } else if (
              option ===
              t(
                'dashboardComponents.Chat.LeftPanel.Contacts.ContactsList.Contact.unpin'
              )
            ) {
              unpinContact();
            } else if (
              option ===
              t(
                'dashboardComponents.Chat.LeftPanel.Contacts.ContactsList.Contact.mark'
              )
            )
              setIsContactMenuVisible(false);
          }}
        />
      )}
      <div className={classes.photoContainer}>
        {contact.jobApplication.user.userProfile.avatar ? (
          <img
            src={getResizedImageUrl({
              url: `avatar/${contact.jobApplication.user.userProfile.avatar}`,
              width: 112,
            })}
            alt="User"
          />
        ) : (
          <NoAvatar>
            {contact.jobApplication.user.userProfile.firstName[0]}{' '}
            {contact.jobApplication.user.userProfile.lastName[0]}
          </NoAvatar>
        )}
      </div>
      <div className={classes.messageContainer}>
        <h4>
          {contact.jobApplication.user.userProfile.firstName}{' '}
          {contact.jobApplication.user.userProfile.lastName}
        </h4>
        <p className={classes.message}>{contact.lastMessage?.content}</p>
      </div>
      <div className={classes.infoContainer}>
        <div
          className={classes.createdAt}
          style={{
            visibility: contact.lastMessage ? 'visible' : 'hidden',
          }}
        >
          {dateToDisplay}
        </div>
        {contact.unreadCount ? (
          <div className={classes.unreadMessageCount}>
            {contact.unreadCount}
          </div>
        ) : null}
      </div>
    </li>
  );
}
